import config from '../config';
import selectedEnvironment from '../env';
const API_URL = `${config[selectedEnvironment].API_URL}`;

const GetNotMatchedbyDateRange = async ( CaseId, date, EndDate,accountCodeId, auth) => {
    const response = await fetch(`${API_URL}/ExternalTransactions/byDateRangeAccountCodeId`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ CaseId, date, EndDate,accountCodeId })
    });
    
    return response;
};


const GetMatchedbyTransactionDateRange = async ( CaseId, StartDate,EndDate,accountCodeId ,auth) => {
    const response = await fetch(`${API_URL}/ExternalTransactionMatches/GetByTransactionDateRange`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ CaseId, StartDate, EndDate,accountCodeId })
    });

    return response;
};


const GetMatchedbyDateRange = async ( CaseId, StartDate,EndDate,accountCodeId, IsMatchDate,auth) => {
    
    const response = await fetch(`${API_URL}/ExternalTransactionMatches/GetByMatchDateRange`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ CaseId, StartDate, EndDate,accountCodeId,IsMatchDate })
    });

    return response;
};



const PreviewExternalTransactions = async (CaseId, AccountCodeId, AccountCodeName, BankType, File, auth) => {
    const formData = new FormData();
    formData.append('CaseId', CaseId);
    formData.append('AccountCodeId', AccountCodeId);
    formData.append('AccountCodeName', AccountCodeName);
    formData.append('BankType', BankType);
    formData.append('File', File); 
    const response = await fetch(`${API_URL}/ExternalTransactions/Preview`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth
        },
        body: formData
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to preview transactions');
    }

    return await response.json();
};

const ImportExternalTransactions = async (CaseId, AccountCodeId, AccountCodeName, BankType, File, auth) => {
    const formData = new FormData();
    formData.append('CaseId', CaseId);
    formData.append('AccountCodeId', AccountCodeId);
    formData.append('AccountCodeName', AccountCodeName);
    formData.append('BankType', BankType);
    formData.append('File', File); 
    const response = await fetch(`${API_URL}/ExternalTransactions/Import`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth
        },
        body: formData
    });

    return response; // Directly return the parsed JSON response
};

const CreateMatch = async (matchDTO, auth) => {
    const response = await fetch(`${API_URL}/ExternalTransactionMatches/Create`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(matchDTO)
    });

    return response; // Optionally return the parsed response
};

const CreateTransaction = async (matchDTO, auth) => {
    const response = await fetch(`${API_URL}/ExternalTransactions/Create`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(matchDTO)
    });

    return response; // Optionally return the parsed response
};

const createMultipleMatches = async (matchDTOs, token) => {

    const response = await fetch(`${API_URL}/ExternalTransactionMatches/CreateMultiple`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(matchDTOs)
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to create matches');
    }

    return await response.json(); // Return parsed response if needed
};

const DeleteMatch = async (deleteDTO, auth) => {
    const response = await fetch(`${API_URL}/ExternalTransactionMatches/Delete`, {
        method: 'DELETE',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(deleteDTO)
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to delete the match');
    }

    return  response; // Return parsed response if needed
};

const GetTransactionSummaryByCaseAndAccount = async (CaseId, AccountCodeId, auth) => {
    const response = await fetch(`${API_URL}/ExternalTransactions/GetTransactionSummaryByCaseAndAccount`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ CaseId, AccountCodeId })
    });

    return response;
};

const DeleteMultipleExternalTransactions = async (caseId, transactionIds, auth, blockFinsiteReimport = false) => {
    const response = await fetch(`${API_URL}/ExternalTransactions/DeleteMultiple`, {
        method: 'DELETE',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            CaseId: caseId,
            TransactionIds: transactionIds,
            BlockFinsiteReimport: !!blockFinsiteReimport,
        })
    });

    return response;
};


const GetExternalTransactionsByDateRange = async (CaseId, Date, EndDate, AccountCodeId, auth) => {
    const response = await fetch(`${API_URL}/ExternalTransactions/GetByDateRange`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ CaseId, Date, EndDate, AccountCodeId })
    });

    return response;
};


const ConvertForeignAmountsToAmount = async (CaseId, AccountCodeId, auth) => {
    const response = await fetch(`${API_URL}/ExternalTransactions/ConvertForeignAmountsToAmount`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ CaseId, AccountCodeId })
    });

    return response;
};

const UpdateExternalTransaction = async (editDTO, oldCredit, oldDebit,auth) => {
    const payload = {
        ...editDTO,       // Spread the existing DTO
        oldCredit,        // Add oldCredit property
        oldDebit          // Add oldDebit property
    };
    const response = await fetch(`${API_URL}/ExternalTransactions/Update`, {
        method: 'PUT',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to update the external transaction');
    }

    return response; // Return the raw response or parsed JSON as needed
};

const DeleteExternalTransaction = async (deleteDTO, auth) => {
    
    const response = await fetch(`${API_URL}/ExternalTransactions/Delete`, {
        method: 'DELETE',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(deleteDTO) // Send the Delete DTO as the request body
    });

    return response; // Return the raw response or parsed JSON as needed
};


const PreviewSumitExternalTransactions = async (CaseId, AccountCodeId, AccountCodeName, File, auth) => {
    const formData = new FormData();
    formData.append('CaseId', CaseId);
    formData.append('AccountCodeId', AccountCodeId);
    formData.append('AccountCodeName', AccountCodeName);
    formData.append('File', File); 
    const response = await fetch(`${API_URL}/ImportExportTransactions/preview-sumit-external-transactions`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth
        },
        body: formData
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to preview Sumit external transactions');
    }

    return await response.json();
};

const ImportSumitExternalTransactions = async (CaseId, AccountCodeId, AccountCodeName, File, auth) => {
    const formData = new FormData();
    formData.append('CaseId', CaseId);
    formData.append('AccountCodeId', AccountCodeId);
    formData.append('AccountCodeName', AccountCodeName);
    formData.append('File', File); 
    const response = await fetch(`${API_URL}/ImportExportTransactions/import-sumit-external-transactions`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth
        },
        body: formData
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to import Sumit external transactions');
    }

    return await response.json();
};

const PreviewHashavshevetExternalTransactions = async (CaseId, AccountCodeId, AccountCodeName, File, auth) => {
    const formData = new FormData();
    formData.append('CaseId', CaseId);
    formData.append('AccountCodeId', AccountCodeId);
    formData.append('AccountCodeName', AccountCodeName);
    formData.append('File', File);
    const response = await fetch(`${API_URL}/ImportExportTransactions/preview-hashavshevet-external-transactions`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth
        },
        body: formData
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to preview Hashavshevet external transactions');
    }

    return await response.json();
};

const ImportHashavshevetExternalTransactions = async (CaseId, AccountCodeId, AccountCodeName, File, auth) => {
    const formData = new FormData();
    formData.append('CaseId', CaseId);
    formData.append('AccountCodeId', AccountCodeId);
    formData.append('AccountCodeName', AccountCodeName);
    formData.append('File', File);
    const response = await fetch(`${API_URL}/ImportExportTransactions/import-hashavshevet-external-transactions`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth
        },
        body: formData
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to import Hashavshevet external transactions');
    }

    return await response.json();
};

const UploadDocument = async (id, caseId, file, auth) => {
    const formData = new FormData();
    formData.append('Id', id);
    formData.append('CaseId', caseId);
    formData.append('Document', file);
    const response = await fetch(`${API_URL}/ExternalTransactions/UploadDocument`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth
        },
        body: formData
    });

    return response;
};

const GetDocumentUrlById = async (id, caseId, auth) => {
    const response = await fetch(`${API_URL}/ExternalTransactions/GetDocumentUrlById`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ Id: id, CaseId: caseId })
    });

    return response;
};

const DeleteDocumentUrl = async (id, caseId, auth) => {
    const response = await fetch(`${API_URL}/ExternalTransactions/DeleteDocumentUrl`, {
        method: 'DELETE',
        headers: {
            "Authorization": 'Bearer ' + auth,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ Id: id, CaseId: caseId })
    });

    return response;
};

const GetByMatch = async (caseId, accountCodeId, matchNumber, auth) => {
    const params = new URLSearchParams({
        caseId,
        accountCodeId,
        matchNumber: String(matchNumber),
    });
    const response = await fetch(`${API_URL}/ExternalTransactionMatches/GetByMatch?${params}`, {
        method: 'GET',
        headers: {
            "Authorization": 'Bearer ' + auth,
        },
    });

    return response;
};

const ExternalTransactionsService = {
    PreviewExternalTransactions,
    ImportExternalTransactions,
    PreviewSumitExternalTransactions,
    ImportSumitExternalTransactions,
    PreviewHashavshevetExternalTransactions,
    ImportHashavshevetExternalTransactions,
    GetMatchedbyDateRange,
    GetMatchedbyTransactionDateRange,
    GetNotMatchedbyDateRange,
    GetByMatch,
    CreateMatch,
    createMultipleMatches,
    DeleteMatch,
    CreateTransaction,
    GetTransactionSummaryByCaseAndAccount,
    DeleteMultipleExternalTransactions,
    GetExternalTransactionsByDateRange,
    ConvertForeignAmountsToAmount,
    UpdateExternalTransaction,
    DeleteExternalTransaction,
    UploadDocument,
    GetDocumentUrlById,
    DeleteDocumentUrl

}

export default ExternalTransactionsService;
